/**
 * AlchamisLogo — Renders the OFFICIAL Alchamis brand asset at a configured height.
 *
 * Used for full brand lockups (footer, admin login). The asset already contains
 * the wordmark, so this component is functionally just the asset displayed at
 * the requested height.
 *
 * Props:
 *  - variant   — accepted for API compatibility ("nav" | "full" | "icon"); has no
 *                visual effect because the master asset is one canonical lockup.
 *  - height    — pixel height (default 80)
 *  - tagline   — optional gold caption rendered below the lockup (full only)
 *  - className — passthrough utility classes
 *  - hover     — when true (default), adds a subtle gold halo on hover
 *  - testId    — data-testid override
 */
// eslint-disable-next-line no-unused-vars
export default function AlchamisLogo({
  variant = "nav",
  height = 80,
  tagline,
  className = "",
  hover = true,
  testId,
}) {
  return (
    <span
      data-testid={testId || `alchamis-logo-${variant}`}
      className={`inline-flex flex-col items-start gap-2 transition-all duration-500 ${
        hover ? "hover:[filter:drop-shadow(0_0_24px_rgba(212,175,55,0.45))]" : ""
      } ${className}`}
      aria-label="Alchamis Group"
    >
      <img
        src="/alchamis-logo.svg"
        alt="AlchamisGroup"
        draggable="false"
        decoding="async"
        loading="eager"
        className="select-none object-contain"
        style={{ height, width: "auto" }}
      />
      {tagline ? (
        <span
          className="font-mono text-gold/70 uppercase"
          style={{
            fontSize: `${Math.max(10, Math.round(height * 0.13))}px`,
            letterSpacing: "0.32em",
            lineHeight: 1,
          }}
        >
          {tagline}
        </span>
      ) : null}
    </span>
  );
}
